export default [
  // "a11ychecker",
  "advlist",
  // "advcode",
  // "advtable",
  "autolink",
  // "checklist",
  // "export",
  "lists",
  "link",
  "image",
  "charmap",
  "preview",
  "anchor",
  "searchreplace",
  "visualblocks",
  // "powerpaste",
  "fullscreen",
  // "formatpainter",
  "insertdatetime",
  "media",
  "table",
  "wordcount",
  "print",
  "help",
]